// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* 字体 */\n/* Colors\n-------------------------- */\n/* 尺寸\n-------------------------- */\n.my-customer-popover {\n  padding: 10px !important;\n  border: 1px solid #d8dee6 !important;\n}\n", ""]);
// Exports
module.exports = exports;
